<template>
    <div class="w-full" :class="containerClass">
        <a :aria-labelledby="ariaName" v-if="link" :href="link" :id="id" :type="type" class="btn" :class="styling" :style="customStyle" :disabled="disabled">
            <slot></slot>
            {{ value }}
        </a>
        <button :id="id" :aria-labelledby="ariaName" v-else :type="type" class="btn" :class="styling" :style="customStyle" :disabled="disabled">
            <slot></slot>
            {{ value }}
        </button>
    </div>
</template>

<script>
export default {
    props: {
        id: String,
        name: String,
        type: String,
        value: String,
        styling: String,
        link: String,
        disabled: Boolean,
        formComponentId: '',

        containerClass: String,

        backgroundColor: String,
        textColor: String
    },

    emits: ['update:selected'],

    data: () => ({
        status: null,
        customStyle: {},
        ariaName: null
    }),

    mounted() {
        if (this.backgroundColor) {
            this.customStyle.backgroundColor = this.backgroundColor;
        }
        if (this.textColor) {
            this.customStyle.color = this.textColor;
        }

        this.name ? (this.ariaName = this.name) : (this.ariaName = 'button');
    }
};
</script>
